import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center',
          justifyContent: 'center', minHeight: '100vh', padding: '2rem',
          fontFamily: 'system-ui, sans-serif', background: '#f8f9fa'
        }}>
          <div style={{
            background: 'white', borderRadius: '12px', padding: '3rem',
            boxShadow: '0 2px 20px rgba(0,0,0,0.1)', textAlign: 'center', maxWidth: '500px'
          }}>
            <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>⚠️</div>
            <h2 style={{ color: '#dc3545', marginBottom: '1rem' }}>Algo sali\u00f3 mal</h2>
            <p style={{ color: '#6c757d', marginBottom: '1.5rem' }}>
              Ha ocurrido un error inesperado. Por favor recargue la p\u00e1gina.
            </p>
            <button
              onClick={() => window.location.reload()}
              style={{
                background: '#0d6efd', color: 'white', border: 'none',
                borderRadius: '8px', padding: '0.75rem 2rem', fontSize: '1rem',
                cursor: 'pointer', marginRight: '0.5rem'
              }}
            >
              Recargar P\u00e1gina
            </button>
            <button
              onClick={() => this.setState({ hasError: false, error: null })}
              style={{
                background: '#6c757d', color: 'white', border: 'none',
                borderRadius: '8px', padding: '0.75rem 2rem', fontSize: '1rem',
                cursor: 'pointer'
              }}
            >
              Intentar de Nuevo
            </button>
            {process.env.NODE_ENV !== 'production' && this.state.error && (
              <pre style={{
                marginTop: '1.5rem', textAlign: 'left', fontSize: '0.75rem',
                background: '#f8d7da', padding: '1rem', borderRadius: '4px',
                overflow: 'auto', maxHeight: '200px'
              }}>
                {this.state.error.toString()}
              </pre>
            )}
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
